import { Component, OnInit, ViewChild, forwardRef } from "@angular/core";
import { FormGroup, FormBuilder, FormControl, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NavController, NavParams, LoadingController, ModalController, IonicModule } from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { ConfigProvider } from "src/app/services/config/config";
import { MdaProvider } from "src/app/services/mda/mda";
import { UserProvider } from "src/app/services/user/user";
import { format } from "date-fns";
import { CommonModule } from "@angular/common";
import { IonModal } from "@ionic/angular/common";
import { MdaEncontroAvaliacaoPage } from "../mda/mda-encontro-avaliacao/mda-encontro-avaliacao.page";
import { ProverDatepickerComponent } from "src/app/components/prover-datepicker/prover-datepicker";
import { noWhitespaceValidator } from "src/app/pipes/no-white-space-validator/no-white-space-validator";

@Component({
  selector: "app-historico",
  templateUrl: "./historico.page.html",
  styleUrls: ["./historico.page.scss"],
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule, TranslateModule, ReactiveFormsModule, ProverDatepickerComponent],
})
export class HistoricoPage implements OnInit {
  @ViewChild("modalNota") modalNota!: IonModal;
  validations_form: FormGroup;
  idMda: string = "";
  idMdaEncontro: string = "";
  toogle: boolean = false;
  dateTime: any = format(new Date(), "yyyy-MM-dd");
  vincularOcorrencia: boolean = false;
  tipoOcorrencias: any = [];
  statusList: any = [
    { id: 1, nome: this.translate.instant("Realizado") },
    { id: 2, nome: this.translate.instant("Não Realizado") },
    { id: 3, nome: this.translate.instant("Desmarcado") },
  ];
  disabled = false;
  status: any;
  validation_messages = {
    data: [{ type: "required", message: this.translate.instant("A data deve ser informada") }],
    resumo: [
      { type: "required", message: this.translate.instant("O resumo deve ser informado") },
      { type: "whitespace", message: this.translate.instant("O resumo não pode conter apenas espaços.") },
    ],
    status: [{ type: "required", message: this.translate.instant("O status deve ser informado") }],
  };

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public loadingController: LoadingController,
    public mdaProvider: MdaProvider,
    public formBuilder: FormBuilder,
    private translate: TranslateService,
    public modalCtrl: ModalController,
    public userProvider: UserProvider,
    public configProvider: ConfigProvider
  ) {
    this.idMda = navParams.get("idMda");
    this.idMdaEncontro = navParams.get("idMdaEncontro");

    this.validations_form = this.formBuilder.group({
      data: new FormControl(this.dateTime, Validators.required),
      resumo: new FormControl(""),
      status: new FormControl("", [
        Validators.required,
        (control) => (control.value === 3 && !this.userProvider.hasConfig(99) ? { notAllowed: true } : null),
      ]),

      vincularOcorrencia: new FormControl(false),
      ocorrencia: new FormControl("", noWhitespaceValidator),
      qualidadeDiscipulador: new FormControl(1),
    });

    if (this.userProvider.hasConfig(98)) {
      this.validations_form.get("resumo")?.setValidators([Validators.required, noWhitespaceValidator]);
      this.validations_form.controls["resumo"].updateValueAndValidity();
    }

    if (!this.idMdaEncontro) {
      this.validations_form.get("status")?.setValidators(Validators.nullValidator);
    }

    this.mdaProvider.getTipoOcorrencia().subscribe((data) => {
      this.tipoOcorrencias = data;
    });
  }

  ngOnInit() {}

  mudarStatus(status: any) {
    this.status = status.detail.value;
    this.validations_form.get("qualidadeDiscipulador")?.setValidators([Validators.nullValidator]);
    this.validations_form.controls["qualidadeDiscipulador"].updateValueAndValidity();
  }

  async onSubmit(historico: any) {
    historico.data = this.validations_form.get("data")?.value;
    this.disabled = true;
    this.status == "1" ? this.openAvaliacao(historico) : this.salvarEncontro(historico);
  }

  async openAvaliacao(historico: any) {
    const isDisci = {
      isDiscipulador: true,
      qualidadeDiscipulo: historico.qualidadeDiscipulador ?? 1,
    };

    const modalPage = await this.modalCtrl.create({ component: MdaEncontroAvaliacaoPage, componentProps: isDisci, animated:false });
    modalPage.present();

    const result = await modalPage.onDidDismiss();
    if (result.data) {
      historico.qualidadeDiscipulador = result.data.qualidadeDiscipulador;
      this.salvarEncontro(historico);
    }
  }

  async salvarEncontro(historico: any) {
    historico.idMda = this.idMda;
    historico.idMdaEncontro = this.idMdaEncontro;

    this.mdaProvider.salvarHistorico(historico).subscribe(async () => {
      await this.modalCtrl.dismiss(true);

      setTimeout(() => {
        this.modalCtrl.dismiss(true);
      }, 1);
    });
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }

  toggleEvent(event: any) {
    this.vincularOcorrencia = !this.vincularOcorrencia;
    if (this.vincularOcorrencia === true) {
      this.validations_form.get("ocorrencia")?.setValidators(Validators.required);
    } else {
      this.validations_form.get("ocorrencia")?.clearValidators();
      this.validations_form.get("ocorrencia")?.reset();
    }
    this.validations_form.controls["ocorrencia"].updateValueAndValidity();
  }
}
